"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createA11yOutlineStyles = exports.getStatusColor = exports.getLabelIconColor = exports.getColor = void 0;
const text_helpers_1 = require("../helpers/text-helpers");
const getColor = (props) => {
    let color;
    if (!props.theme) {
        return;
    }
    switch (props.appearance) {
        case text_helpers_1.TextAreaAppearance.ReadOnly:
        case text_helpers_1.TextInputAppearance.ReadOnly:
            color = props.theme.colors.content.primary;
            break;
        case text_helpers_1.TextAreaAppearance.Disabled:
        case text_helpers_1.TextInputAppearance.Disabled:
            color = props.theme.colors.content.disabled;
            break;
        default:
            color = props.theme.colors.content.active;
    }
    return color;
};
exports.getColor = getColor;
const getLabelIconColor = (props) => {
    let color;
    if (!props.theme) {
        return;
    }
    switch (props.appearance) {
        case text_helpers_1.TextAreaAppearance.ReadOnly:
        case text_helpers_1.TextInputAppearance.ReadOnly:
            color = props.theme.colors.content.primary;
            break;
        case text_helpers_1.TextAreaAppearance.Disabled:
        case text_helpers_1.TextInputAppearance.Disabled:
            color = props.theme.colors.content.disabled;
            break;
        // case TextAreaAppearance.Search:
        // case TextInputAppearance.Search:
        //   color = props.theme.interaction.recipe400.default;
        //   break;
        default:
            color = props.theme.colors.content.active;
    }
    return color;
};
exports.getLabelIconColor = getLabelIconColor;
const getStatusColor = (props) => {
    let color;
    if (!props.theme) {
        return;
    }
    switch (props.appearance) {
        case text_helpers_1.TextAreaAppearance.Error:
        case text_helpers_1.TextInputAppearance.Error:
            color = props.theme.colors.signal.error;
            break;
        case text_helpers_1.TextAreaAppearance.Disabled:
        case text_helpers_1.TextInputAppearance.Disabled:
            color = props.theme.colors.border.disabled;
            break;
        default:
            color = props.theme.colors.border.default;
    }
    return color;
};
exports.getStatusColor = getStatusColor;
function createA11yOutlineStyles(props) {
    return `
			outline: 1px solid ${props.theme.colors.content.secondary};
			outline-offset: ${props.theme.size.static100};
		`;
}
exports.createA11yOutlineStyles = createA11yOutlineStyles;
